import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { domainSelector } from '../../domain/domain-redux';
import { getFromLocalStorage, saveToLocalStorage } from "../utils/app-storage";
var KEY_UNTIL = 'block-until';
/**
 * Custom hook for determining if a user is blocked.
 */
export var useIsBlocked = function (initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var blockMessage = useSelector(domainSelector.getLastBlockCommandMessage);
    var _a = useState(initialValue), isBlocked = _a[0], setIsBlocked = _a[1];
    useEffect(function () {
        var _a, _b;
        var now = Math.floor(Date.now() / 1000);
        var until = null;
        if ((_b = (_a = blockMessage === null || blockMessage === void 0 ? void 0 : blockMessage.meta) === null || _a === void 0 ? void 0 : _a.commandProps) === null || _b === void 0 ? void 0 : _b.until) {
            until = blockMessage.meta.commandProps.until;
            saveToLocalStorage(KEY_UNTIL, until); // Persist in case of page-reload
        }
        else {
            var untilRaw = getFromLocalStorage(KEY_UNTIL);
            until = untilRaw ? parseInt(untilRaw) : null;
        }
        setIsBlocked(!!until && until > now);
    }, [blockMessage]);
    return [isBlocked, setIsBlocked];
};
